export { default as SellerGuaranteeText } from './SellerGuaranteeText';